import { getDefaultEndLongEventsBy } from 'owa-calendar-cloud-settings';
import { differenceInMinutes, OwaDate } from 'owa-datetime';

/**
 * Gets the type of the interval in case it was changed (short to long events or long to short events)
 * @param previousStart
 * @param previousEnd
 * @param newStart
 * @param newEnd
 */
export default function getIntervalChangedType(
    previousStart: OwaDate,
    previousEnd: OwaDate,
    newStart: OwaDate,
    newEnd: OwaDate
): IntervalChangedType | null {
    const previousDuration = differenceInMinutes(previousEnd, previousStart);
    const newDuration = differenceInMinutes(newEnd, newStart);

    const interval = 60 - getDefaultEndLongEventsBy();

    if (previousDuration === 0 && newDuration !== 0 && newDuration < interval) {
        return IntervalChangedType.ZeroToShort;
    }

    if (previousDuration === 0 && newDuration >= interval) {
        return IntervalChangedType.ZeroToLong;
    }

    if (newDuration === 0 && previousDuration !== 0 && previousDuration < interval) {
        return IntervalChangedType.ShortToZero;
    }

    if (newDuration === 0 && previousDuration >= interval) {
        return IntervalChangedType.LongToZero;
    }

    if (
        (previousDuration < interval && newDuration < interval) ||
        (previousDuration >= interval && newDuration >= interval)
    ) {
        return IntervalChangedType.None;
    }

    if (previousDuration < interval && newDuration >= interval) {
        return IntervalChangedType.ShortToLong;
    }

    if (previousDuration >= interval && newDuration < interval) {
        return IntervalChangedType.LongToShort;
    }

    return null;
}

export enum IntervalChangedType {
    None,
    ShortToLong,
    LongToShort,
    ZeroToShort,
    ZeroToLong,
    ShortToZero,
    LongToZero,
}
